import { match } from 'ts-pattern'

import { decimalFromPercentage } from '@sequencehq/utils'
import { format } from '@sequencehq/utils/dates'
import { IntegrationServices } from '@sequencehq/api'

import {
  RevenueClassification,
  RevenueRecognitionMethod
} from 'common/types/revenueRecognition.types'
import { AggregatedLineItemGroupMutation, RateDisplay } from 'Invoices/types'
import { DATE_FORMAT_API } from 'Invoices/constants'

export const toLineItem = (props: {
  id: string | undefined
  title: string
  quantity: string
  rate: string
  rateDisplay: RateDisplay
  servicePeriod: { start: Date; endInclusive: Date } | undefined
  revenueRecognitionMethod: RevenueRecognitionMethod | undefined
  revenueClassification: RevenueClassification | undefined
  taxCategoryId: string
  descriptionEnabled: boolean
  description: string
  externalIds: Array<{ key: IntegrationServices; value: string }>
  productId: string | undefined
  priceId: string | undefined
  creditGrantId: string | undefined
}): AggregatedLineItemGroupMutation['lineItems'][0] => {
  return {
    id: props.id ?? crypto.randomUUID(),
    title: props.title,
    quantity: props.quantity,
    rateDisplay: props.rateDisplay,
    taxCategoryId: props.taxCategoryId,
    rate: match(props.rateDisplay)
      .with('ABSOLUTE', () => props.rate)
      .with('PERCENTAGE', () => decimalFromPercentage(props.rate))
      .exhaustive(),
    taxRate: '0',
    externalIds: props.externalIds,
    description:
      props.descriptionEnabled && !!props.description ? props.description : '',
    productId: props.productId,
    priceId: props.priceId,
    creditGrantId: props.creditGrantId,
    servicePeriod: props.servicePeriod
      ? {
          startDate: format(props.servicePeriod.start, DATE_FORMAT_API),
          endDate: format(props.servicePeriod.endInclusive, DATE_FORMAT_API)
        }
      : undefined,
    revenueRecognitionMethod: props.revenueRecognitionMethod,
    revenueClassification: props.revenueClassification
  }
}
